module.exports = "/remote-dist/53fd4cdd60babde865ed8b56a032b60c.png";